import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=186a6540"
import script from "./RegisterResult.vue?vue&type=script&lang=js"
export * from "./RegisterResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186a6540')) {
      api.createRecord('186a6540', component.options)
    } else {
      api.reload('186a6540', component.options)
    }
    module.hot.accept("./RegisterResult.vue?vue&type=template&id=186a6540", function () {
      api.rerender('186a6540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_division/RegisterResult.vue"
export default component.exports